import _ from "lodash";
import moment from "moment";
import "moment/locale/id";

const noEmpty = str => {
  return str ? str : "-";
};
const truncate = (str, options) => {
  return _.truncate(str, options);
};
const niceDate = str => {
  return moment(str, "YYYY-MM-DD").format("DD MMM YYYY");
};

export default {
  noEmpty,
  truncate,
  niceDate
};
